
import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import { toast } from 'react-toastify';
import { useTitle } from '../../hooks/useTitle';

const UserActivation = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { get } = useApi();

  useTitle('Ton Bébé | アカウント有効化');

  useEffect(() => {
    if (token) {
      get({
        endpoint: `users/${ token }/activate`,
        params: { api_mode: 'true' },
        skipAuth: true,
        onSuccess: (data) => {
          toast.success('アカウントの有効化が完了しました。ログインしてください。');
          navigate('/');
        },
        onError: (err) => {
          toast.error('アカウントの有効化に失敗しました。時間をおいて再度お試しください。');
          navigate('/');
        },
      });
    }
  }, [token, get, navigate]);

  return (
    <main className="sub">
      <section className="activation">
        <p>アカウントの有効化を処理しています...</p>
      </section>
    </main>
  );
};

export default UserActivation;
